<template>
  <viewer659/>
</template>

<script>

import Viewer659 from "@/views/boards/single-page/659/Viewer.vue";

export default {
  components: {Viewer659}
}

</script>

<style scoped>

</style>
